<template>
  <InputWrapper
    v-slot="{ inputId }"
    :input-id="id"
    :label="t('shipments.freightAllowance.freightAllowance')"
    class="freight-allowance-filter"
    optional
  >
    <MoneyFilter
      :id="inputId"
      v-model="freightAllowanceFilter"
      :placeholder="t('shipments.freightAllowance.freightAllowance')"
      append-to="body"
    />
  </InputWrapper>
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import {
  MoneySearchFilter,
  OrderSearchCriteria,
  ShipmentSearchCriteria,
} from '@/model';

import MoneyFilter from '@/components/search/MoneyFilter.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';

const internalValue = defineModel({
  type: Object as PropType<OrderSearchCriteria | ShipmentSearchCriteria>,
  required: true,
});

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});
const { id } = toRefs(props);

const { t } = useI18n();

const freightAllowanceFilter = computed({
  get() {
    return new MoneySearchFilter({
      min: internalValue.value.freightAllowance?.min,
      max: internalValue.value.freightAllowance?.max,
      currency: internalValue.value.freightAllowance?.currency,
    });
  },
  set(newVal: MoneySearchFilter) {
    internalValue.value.freightAllowance = new MoneySearchFilter(newVal);
  },
});
</script>
